export const PromiseGenesys = (
  command: string,
  action: string,
  payload: unknown
) => {
  return new Promise((resolve, reject) => {
    window.Genesys(
      command,
      action,
      payload,
      (response) => {
        setTimeout(() => resolve(response), 500)
      },
      (err) => {
        if (
          err === 'Messenger is already opened.' ||
          err === 'Messenger is already closed.'
        )
          // handle these without reject
          return
        console.error(err)
        reject(err)
      }
    )
  })
}

export const initWebChat = async (entryPoint: string, isMobile?: boolean) => {
  await PromiseGenesys('command', 'database.set', {
    messaging: {
      customAttributes: {
        chatURL: document.location.href,
        isAuthenticated: isAuthenticated(),
        entryPoint: entryPoint,
        environment: isMobile ? 'mobileApp' : 'web',
      },
    },
  })
  await PromiseGenesys('command', 'Messenger.open', {})
}

export const closeOpenWebChat = async (entryPoint: string) => {
  const isMobile = entryPoint === '/dashboard/webchat'
  try {
    window.Genesys(
      'command',
      'Messenger.close',
      {},
      () => {
        // resolved
        initWebChat(entryPoint, isMobile)
      },
      (error) => {
        if (error === 'Messenger is already closed.') {
          initWebChat(entryPoint, isMobile)
        }
      }
    )
  } catch (error) {
    console.error(error)
  }
}

const isAuthenticated = () => {
  const state = JSON.parse(localStorage.getItem('state') as string)

  return !!state?.auth?.jwt
}
